.chart{height:26rem;background:#fff;padding:1rem;border-radius:4px}
/*# sourceMappingURL=questionnaire-history-chart.component-S5G2YPVG.css.map */
